import { createSelector } from "@reduxjs/toolkit"; 
import { RootState } from "types"; 

export const getAdminManagementState = (state:RootState) => state.adminMangmentState;

export const selectStatusFilter = createSelector(
    [getAdminManagementState],
    (adminManagementState) => adminManagementState?.statusFilter || "ALL"
);

export const selectData = createSelector(
    [getAdminManagementState],
    (adminMangmentState) => adminMangmentState?.data || []
);

export const selectIsLoading = createSelector(
    [getAdminManagementState],
    (adminMangmentState) => adminMangmentState?.isLoading || false
);

export const selectError = createSelector(
    [getAdminManagementState],
    (adminMangmentState) => adminMangmentState?.error
);


export const selectFilteredData = createSelector(
    [selectData, selectStatusFilter],
    (data, statusFilter) =>
        statusFilter === "ALL" ? data : data.filter(item => item.status === statusFilter)
);
